import { Controller } from '@hotwired/stimulus'
import { MarkerArea } from '@markerjs/markerjs3'

export default class extends Controller {
  static editor
  static outlets = ["video-reviewer--annotation-tools"]

  selectedMarkerName = "FreehandMarker"

  markerArrowType = 'end'
  markerStrokeColor = 'rgb(231, 74, 60)'
  markerStrokeWidth = 5

  getVisibility(){
    return this.element.dataset.visible === 'true'
  }

  toggleVisibility(params){
    const { isVisible, height, width } = params

    const isOverlayVisible = isVisible ?? this.getVisibility()
    
    // Toggle overlay visibility
    this.element.dataset.visible = !isOverlayVisible

    if (height && width){
      this.setupAnnotationCanvas({
        height,
        width,
      })
    }
  }

  setupAnnotationCanvas(params){
    const { height, width } = params

    if (this.editor){
      this.editor.restoreState({
        height: -1,
        markers: [],
        version: 3,
        width: -1,
      })

      return
    }

    // Create Canvas
    const canvas = document.createElement('canvas');
    canvas.id = 'AnnotationCanvas'
    canvas.width = width
    canvas.height = height

    // Fill Canvas (Debugging)
    // let ctx = canvas.getContext("2d")
    // ctx.fillStyle = "green"
    // ctx.fillRect(0, 0, canvas.width, canvas.height)

    // Create Image
    const targetImg = document.createElement('img')
    targetImg.src = canvas.toDataURL('image/png')

    // Setup Editor
    this.editor = new MarkerArea()
    this.editor.targetImage = targetImg

    // Remove Images
    targetImg.remove()
    canvas.remove()

    this.editor.addEventListener('areashow', (e) => {
      this.editor.shadowRoot.querySelectorAll('.canvas-container')[0].getElementsByTagName('svg')[0].style.margin = 0
    })

    this.editor.addEventListener('markerselect', (e) => {
      this.createMarker(this.selectedMarkerName)
    })

    this.element.appendChild(this.editor)

    this.createMarker(this.selectedMarkerName)
  }

  modifyCanvasSize(params = {}){
    const { height, width } = params
    
    if (this.editor){
      this.editor.targetHeight = height
      this.editor.targetWidth = width
    }
  }

  selectMarkerName(markerName){
    this.selectedMarkerName = markerName
    this.createMarker(this.selectedMarkerName)
  }

  selectMarkerProperty(name, value){
    this[name] = value
    this.createMarker(this.selectedMarkerName)
  }

  // markerName: 'ArrowMarker' | 'FreehandMarker' | 'FrameMarker' | 'LineMarker'
  createMarker(markerName){
    if (!markerName) return

    const marker = this.editor.createMarker(markerName)
    marker.strokeColor = this.markerStrokeColor
    marker.strokeWidth = this.markerStrokeWidth
    marker.arrowType = this.markerArrowType
  }

  async getEditorState(){
    if (this.editor){
      return await this.editor.getState()
    }

    return {}
  }
}
